export default __webpack_public_path__ + "static/media/pug.3a6838ac.png";